import { Link } from "react-router-dom";
import type { Drama } from "@/types";

interface DramaCardProps {
  drama: Drama;
  rank?: number;
}

export default function DramaCard({ drama, rank }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.cover}
          alt={drama.title}
          title={`${drama.title} 剧集封面 - 漂亮的保姆`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-900/80 text-background-50 text-xs font-medium">
          {drama.rating.toFixed(1)}
        </span>
        {typeof rank === "number" && (
          <span className="absolute top-0 left-0 w-7 h-7 rounded-br-lg bg-accent-500 text-background-50 text-sm font-bold flex items-center justify-center">
            {rank}
          </span>
        )}
        <span className="absolute bottom-0 left-0 right-0 px-2 py-1 bg-gradient-to-t from-foreground-950/85 to-transparent text-background-50 text-xs">
          {drama.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {drama.genre} · {drama.year}
        </p>
        <p className="mt-1 text-xs text-foreground-400 truncate">
          {drama.cast.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}